import React from 'react';
import CardUI from '../../../widgets/layout/CardUI';
import EmptyListUI from '../../../widgets/output/EmptyListUI';
import IconButtonUI from '../../../widgets/action/IconButtonUI';

const NachFailureRecordsListUI = ({ context, records, onUpdateClick }) => {
  return (
    <CardUI className='scard'>
      <div style={{ maxHeight: '500px', overflowY: 'auto', overflowX: 'auto' }}>
        <table className='table_cr table' style={{ minWidth: '1400px' }}>
          <thead className='g_sticky_header'>
            <tr>
              <th>S.No</th>
              <th>Transaction ID</th>
              <th>Customer Name</th>
              <th>Reason Code</th>
              <th>Reason Description</th>
              <th>Scheme Code</th>
              <th>Status</th>
              <th>Presentment Mode</th>
              <th>Unique Reg. No</th>
              <th>Closure Status</th>
              <th>Cure Date</th>
            </tr>
          </thead>
          <tbody>
            {
              records && records.length > 0 ? records.map((record, idx) => (
                <tr key={idx}>
                  <td className="g_text_left">{idx + 1}</td>
                  <td className="g_text_left">{record.transactionId || '-'}</td>
                  <td className="g_text_left">{record.customerName || '-'}</td>
                  <td className="g_text_left">{record.reasonCode || '-'}</td>
                  <td className="g_text_left">{record.reasonDescription || '-'}</td>
                  <td className="g_text_left">{record.schemeCode || '-'}</td>
                  <td className="g_text_left">{record.status || '-'}</td>
                  <td className="g_text_left">{record.presentmentMode || '-'}</td>
                  <td className="g_text_left">{record.uniqueRegistrationNumber || '-'}</td>
                  <td className="g_flex_h g_flex_middle">{record.closureStatus || '-'}<IconButtonUI icon='icon-pencil' onClick={onUpdateClick} /></td>
                  <td className="g_text_left">{record.cureDate || '-'}</td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="11" className="g_text_center">
                    <EmptyListUI
                      context={context}
                      createEnabled={false}
                      createDisabledMessageLabel="No NACH Failures Found"
                    />
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
    </CardUI>
  );
};

export default NachFailureRecordsListUI;
